<form #previewForm="ngForm" novalidate="novalidate" autocomplete="off">
  @if (!isSend){
    <div disableRightClick>
      <div class="modal-header inside-body">
        <button id="add-interim-popup-close" type="button" class="close" aria-label="Close" (click)="decline()">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body custom__scroll">
        <!-- Image -->
        <div class="item" *ngIf="images.length !== 0">
          <img alt="" class="w-100 h-100" *ngFor="let image of images"
               onerror="this.src='../../../../assets/images/default_spinner.svg';"
               [src]="image" />
        </div>
      </div>
      <div class="modal-footer">
        <button id="add-interim-popup-cancel" type="button" class="button secondary__button large__button position-static"
                (click)="decline()">Cancel</button>
        <button id="add-interim-popup-add" type="button" class="button primary__button large__button position-static"
                [disabled]="!previewForm.valid || previewForm.invalid || sending"
                (click)="sendPreview()">Send</button>
      </div>
    </div>
  }@else{
    @if(sentSuccess){
      <div class="modal-body my-3">
        <h3 class="sent-message">
          Report Sent Successfully!
        </h3>
        <div class="color--gray font-size-12 mt-10 mb-50 text-center">
          Report was sent an email with a images to preview
        </div>
        <div class="text-center">
          <svg-icon name="email_sent"></svg-icon>
        </div>
        <div class="text-center mt-2">
          <button type="button" class="button large__button ghost__button font-size-18" (click)="decline()">
            Continue
          </button>
        </div>
      </div>
    }@else{
      <div class="modal-body my-3">
        <div class="label">Recipient Email</div>
        <input type="text" class="input input__large input__blue" [(ngModel)]="borrowerEmail"
               placeholder="hello@mail.com" name="EMAIL" required restrictFirstSpace
               [ngClass]="{'error-input' : ((!BORROWER_EMAIL.valid && !BORROWER_EMAIL.untouched) || previewForm?.submitted) && (BORROWER_EMAIL.errors?.required || BORROWER_EMAIL.errors?.pattern)}"
               [pattern]="commonService.emailPattern" id="BORROWER_EMAIL" #BORROWER_EMAIL="ngModel" autocomplete="new-password"  />

        <div class="text-center mt-4">
          <button id="report-preview-popup-send" type="button" class="button primary__button large__button position-static"
                  [disabled]="!previewForm.valid || previewForm.invalid || sending"
                  (click)="sendReport()">{{sending ? 'Sending...' : 'Send'}}</button>
        </div>
      </div>
    }
  }
</form>
